import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "CategorySort" }
const _hoisted_2 = { class: "CategorySort-label" }
const _hoisted_3 = { class: "CategorySort-labelText" }
const _hoisted_4 = {
  key: 0,
  class: "CategorySort-links"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "CategorySort-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("img", {
        src: "/frontend/images/product/list/icon-category-sort.svg",
        alt: "sort"
      }, null, -1)),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.categorySortLabel) + ":", 1)
    ]),
    (_ctx.sort)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sort.available, (sortBtn) => {
            return (_openBlock(), _createElementBlock("button", {
              class: _normalizeClass({ 'CategorySort-link': true, 'is-active': sortBtn.value === _ctx.sort.selected }),
              key: sortBtn.value,
              onClick: ($event: any) => (_ctx.sortProduct(sortBtn.value)),
              type: "button"
            }, _toDisplayString(sortBtn.label), 11, _hoisted_5))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.productCount) + " " + _toDisplayString(_ctx.productTotalLabel), 1)
  ]))
}